// extracted by mini-css-extract-plugin
export default {"calendarTopTick":"TopPartOfCalendar_calendarTopTick__h1qCa","calendarTopText":"TopPartOfCalendar_calendarTopText__lH6jF"};